/*
 * @license
 * Copyright© Celligence LLC - 2024
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React from "react";
import { AngelaiFooter } from "footer-component";
import "./index.css";
 
const CustomFooter = () => {

  return (
    <div className="custom-footer">
      <AngelaiFooter showServicesDisclaimer={false} showTechSolutionDisclaimer={false} showequalHousingOpportunity={true}/>
    </div>
  );
};

export default React.memo(CustomFooter);
